(() => {
  if (customElements.get('godness-header')) return;
  class GodnessHeader extends HTMLElement {
    constructor() {
      super();
      this.frame = 0;
      this.queueUpdate = this.queueUpdate.bind(this);
      this.update = this.update.bind(this);
      this.refresh = this.refresh.bind(this);
      this.cancelUpdate = this.cancelUpdate.bind(this);
      this.openMenu = this.openMenu.bind(this);
      this.closeMenu = this.closeMenu.bind(this);
      this.onMenuClose = this.onMenuClose.bind(this);
      this.onMenuClick = this.onMenuClick.bind(this);
    }
    connectedCallback() {
      this.opener = this.querySelector('[data-menu-open]');
      this.dialog = this.querySelector('[data-menu-dialog]');
      this.closer = this.querySelector('[data-menu-close]');
      this.opener?.addEventListener('click', this.openMenu);
      this.closer?.addEventListener('click', this.closeMenu);
      this.dialog?.addEventListener('close', this.onMenuClose);
      this.dialog?.addEventListener('click', this.onMenuClick);
      if (!this.hasAttribute('data-godness-home')) return;
      this.announcement = this.querySelector('.godness-announcement');
      this.update();
      window.addEventListener('scroll', this.queueUpdate, { passive: true });
      window.addEventListener('resize', this.queueUpdate);
      window.addEventListener('pageshow', this.refresh);
      window.addEventListener('pagehide', this.cancelUpdate);
      window.addEventListener('load', this.queueUpdate);
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.queueUpdate);
        this.resizeObserver.observe(this);
        if (this.announcement) this.resizeObserver.observe(this.announcement);
      }
      this.queueUpdate();
    }
    disconnectedCallback() {
      this.closeMenu();
      this.restoreScroll();
      this.opener?.removeEventListener('click', this.openMenu);
      this.closer?.removeEventListener('click', this.closeMenu);
      this.dialog?.removeEventListener('close', this.onMenuClose);
      this.dialog?.removeEventListener('click', this.onMenuClick);
      window.removeEventListener('scroll', this.queueUpdate);
      window.removeEventListener('resize', this.queueUpdate);
      window.removeEventListener('pageshow', this.refresh);
      window.removeEventListener('pagehide', this.cancelUpdate);
      window.removeEventListener('load', this.queueUpdate);
      this.resizeObserver?.disconnect();
      this.cancelUpdate();
    }
    openMenu() {
      if (!this.dialog || this.dialog.open) return;
      this.scrollY = window.scrollY;
      const body = document.body;
      this.savedBody = Object.fromEntries(['position', 'top', 'left', 'right', 'width', 'overflow'].map(key => [key, body.style[key]]));
      Object.assign(body.style, { position: 'fixed', top: `-${this.scrollY}px`, left: '0', right: '0', width: '100%', overflow: 'hidden' });
      this.dialog.showModal();
      this.opener.setAttribute('aria-expanded', 'true');
    }
    closeMenu() {
      if (this.dialog?.open) this.dialog.close();
      this.restoreScroll();
      this.opener?.setAttribute('aria-expanded', 'false');
    }
    restoreScroll() {
      if (!this.savedBody) return;
      Object.assign(document.body.style, this.savedBody);
      this.savedBody = null;
      window.scrollTo({ top: this.scrollY, behavior: 'instant' });
      if (this.isConnected && this.hasAttribute('data-godness-home')) this.refresh();
    }
    onMenuClose() {
      this.restoreScroll();
      this.opener?.setAttribute('aria-expanded', 'false');
      if (this.isConnected) this.opener?.focus({ preventScroll: true });
    }
    onMenuClick(event) {
      if (event.target.closest('a')) { this.closeMenu(); return; }
      if (event.target !== this.dialog) return;
      const rect = this.dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeMenu();
    }
    queueUpdate() { if (!this.frame) this.frame = requestAnimationFrame(this.update); }
    cancelUpdate() { cancelAnimationFrame(this.frame); this.frame = 0; }
    refresh() { this.cancelUpdate(); this.update(); }
    update() {
      this.frame = 0;
      if (!this.isConnected) return;
      const y = Math.max(0, this.savedBody ? this.scrollY : window.scrollY);
      const scrolled = y > 24;
      this.classList.toggle('is-scrolled', scrolled);
      if (this.announcement) {
        const announcementHeight = this.announcement.getBoundingClientRect().height;
        const hiddenHeight = Math.min(y, announcementHeight);
        if (announcementHeight !== this.announcementHeight || hiddenHeight !== this.hiddenAnnouncementHeight) {
          this.announcementHeight = announcementHeight;
          this.hiddenAnnouncementHeight = hiddenHeight;
          this.style.setProperty('--godness-announcement-visible', `${announcementHeight - hiddenHeight}px`);
          this.style.setProperty('--godness-announcement-offset', `${-hiddenHeight}px`);
        }
      }
      const height = Math.ceil(this.getBoundingClientRect().height);
      if (height > 0 && height !== this.measuredHeight) {
        this.measuredHeight = height;
        document.documentElement.style.setProperty('--godness-header-height', `${height}px`);
      }
    }
  }
  customElements.define('godness-header', GodnessHeader);
})();
